import { render, staticRenderFns } from "./GroupMessageCreate.vue?vue&type=template&id=315ce055&"
import script from "./GroupMessageCreate.vue?vue&type=script&lang=js&"
export * from "./GroupMessageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports